<section class="section-product-hero">
  <div class="section-container">
    <div class="product-hero-content-box">
      <div>
        <span class="product-hero-subheading mar-b-16"
          >{{ heroData?.badge }}
        </span>
        <h1 class="product-hero-header">
          {{ heroData?.header }}
        </h1>
        <div
          class="landing-hero-content mar-t-24"
          [innerHtml]="heroData?.paragraph | toHtml"
        ></div>
        <div class="landing-btn mar-t-48 align-c">
          <a
            href="{{ heroData?.button1?.url | urlParams:queryParams}}"
            target="{{ heroData?.button1?.target }}"
            class="btn btn-full"
            >{{ heroData?.button1?.text }}</a
          >
          <app-common-talktosales-button
            [text]="heroData?.button2?.text"
          ></app-common-talktosales-button>
        </div>
      </div>
      <img src="{{ heroData?.image?.url }}" alt="{{ heroData?.image?.alt }}" />
    </div>
  </div>
</section>
